module.exports = __webpack_public_path__ + "img/html.f2282f94.png";